import * as React from 'react';
import {findDOMNode} from 'react-dom';
import Tooltip from 'original/Tooltip/Tooltip';
import {withStyles, WithStyles, createStyles} from 'original/styles';
import wrapDisplayName from 'recompose/wrapDisplayName';
import {StyledComponentProps} from '../styles/withStyles';
import * as classNames from 'classnames';

// for a reason beyond my comprehension I can't get this to work properly with clean TS, so I hacked the hell out of it. sorry. Or, CTO at CrazyLister :(

const styles = createStyles({
  root: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
export default function(titleProp: string = 'children') {
  return function<P extends StyledComponentProps<'root'>>(
    WrappedComponent: React.ComponentType<P & React.ClassAttributes<any>>
  ): React.ComponentType<P> {
    const withEllipsis = withStyles(styles, {name: 'withEllipsis'})(class extends React.PureComponent<
      P & WithStyles<typeof styles>,
      {ellipsis: boolean}
    > {
      private readonly rootRef: React.RefObject<React.ReactInstance>;
      constructor(props) {
        super(props);
        this.rootRef = React.createRef();
        this.state = {
          ellipsis: false,
        };
      }

      componentDidMount() {
        const node: Element = findDOMNode(this.rootRef.current) as Element;
        this.setState({ellipsis: node.scrollWidth > node.clientWidth});
      }

      componentDidUpdate(prevProps) {
        if (this.props.children !== prevProps.children) {
          this.componentDidMount();
        }
      }

      render() {
        const {ellipsis} = this.state;
        const inner = <WrappedComponent ref={this.rootRef} {...this.props} />;
        if (ellipsis) {
          return (
            <Tooltip
              className={classNames(this.props.classes.root, this.props['className'])}
              title={this.props[titleProp]}
            >
              {inner}
            </Tooltip>
          );
        }
        return inner;
      }
    } as React.ComponentType);
    withEllipsis.displayName = wrapDisplayName(WrappedComponent, 'withEllipsis');
    return withEllipsis as any;
  };
}
